import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import saveAs from 'file-saver';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';


@Component({
  selector: 'app-epc-pv-done',
  templateUrl: './epc-pv-done.component.html',
  styleUrls: ['./epc-pv-done.component.scss']
})
export class EpcPvDoneComponent implements OnInit {

  public userId: any;
  public appVerificationItems: MenuItem[];

  public epvPVDoneData: any = [];

  public loading: boolean = false;

  public subscriptions: any = []
  public subjectSub: any;

  public imagePathJE: any = [];
  public listGPSCoordinatesJE: any = [];

  public landArea: number = null;
  public surveyArea: number = null;
  public coordinateError: any;
  public isGPSError: boolean = false;

  public refreshLocation: any;

  public imageError: string;
  public uploadOptions: any[];
  public documentList: any = [];
  public selctedFileType: any;

  public showActionDialog: boolean = false;
  public geolocationsarray: any = [];
  public overlays: any = [];
  public mapEnable = false;

  public contractorList: any = [];
  public selectedContractor: any;

  public geoLocMulArray: any[] = [];

  options = {
    center: { lat: 29.0588, lng: 76.0856 },
    zoom: 17,
    mapTypeId: google.maps.MapTypeId.SATELLITE,
    draggable: true,
    // icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
  };

  public selectedStatus: any;
  public remarks: any;
  public items: any = [];
  public selectedRowData: any;

  public ipAddress: any = '000.000.000';
  public showDetailTable: boolean = false;
  public epcDataForAppLandDetails: any = [];

  constructor(
    private loader: AppLoaderService,
    private activityRecordService: ActivityRecordService,
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private cryptoJsService: CryptoJsService,
    private ipService: IpAddressService,
    public cd: ChangeDetectorRef,
    public router: Router,
    private service: BaseService,
    private vendorService: VendorDashboardService,
  ) { }

  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.epvPVDoneData, 'EPC_PV_Done');
        },
      },
    ];

    this.getStatusList();
    this.getIP();

    this.loadContractor(this.userId);
  }

  onSelectContractor(){
    this.showDetailTable = true;
    if(this.selectedContractor){
      this.loadData(this.selectedContractor?.ContractorCode, this.userId);
    }
  }

  getStatusList() {

    setTimeout(() => {
      (this.items = [
        {
            "$id": "2",
            "id": "1",
            "flag": "A",
            "status": "Approve"
        },
        {
            "$id": "3",
            "id": "3",
            "flag": "RP",
            "status": "Return Process"
        },
        // {
        //     "$id": "4",
        //     "id": "2",
        //     "flag": "R",
        //     "status": "Reject"
        // }
    ])
      // (this.filteredComponentMaster = [...this.componentMasterList]);
    }, 100);
  
    // let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    // let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    // this.deptDashBoardService
    //   .getStatusMasterEPC(JSON.parse(payload)?.sub)
    //   .pipe(first())
    //   .subscribe({
    //     next: (data) => {
    //       this.items = data.$values;
    //     },
    //     error: () => {
    //       this.messageService.add({
    //         severity: 'error',
    //         summary: 'Error Message',
    //         detail: 'Status Master cant be Loaded',
    //       });
    //     },
    //   });
  }

  loadContractor(userId) { 
    this.loader.start();
    let sub = this.vendorService
    .getContractorMaster(userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();          
          if (data.length > 0) {
            this.contractorList = data;
          }
          else {
            this.contractorList = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          this.loader.close(); 
          this.contractorList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  loadData(conId, userId) { 
    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService
      .getAppsForReVerEPC(conId, userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          
          if (data.length > 0) {
            this.epvPVDoneData = data;
            // this.appVerificationModel = this.farmerUHBVNpvData;
            // this.mobileFarmerUHBVNpvData = data;
            // this.mobileFarmerUHBVNpvData = this.farmerUHBVNpvData.filter(val => val.Fin_Year == this.selectedYear);  
          }
          else {
            this.epvPVDoneData = [];
            // this.appVerificationModel = []
            // this.mobileFarmerUHBVNpvData = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }

          this.activityRecordService.activityRecord( this.userId, 'EPC PV Done (grid load)', '', new Date(), 'Success' );
        },
        error: (err) => {
          this.loading = false;
          this.epvPVDoneData = [];
          this.activityRecordService.activityRecord( this.userId, 'EPC PV Done Error(grid load)', '', new Date(), `${err}` );

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  refreshTable() {
    if(this.selectedContractor){
      this.loadData(this.selectedContractor?.ContractorCode, this.userId);
    }
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Application No': d?.APP_ID,
          'Total Area (in Acre)': d?.TotalArea,
          'Farmer Name': d?.Name,
          'Father Name': d?.NamFather_namee,
          'Mobile No': d?.Mobile,
          'Contractor Name': d?.ContractorName,
          'Outlet': d?.Outlets,
          'Agreement No': d?.AgreementNo,
          'Programme Name': d?.ProposedSystem,
          'Total Area': d?.TotalArea,
          'District': d?.District,  
          'Block': d?.Block,
          'Village': d?.Village,
          'JE Remarks': d?.JE_Remarks,
          'JE Status': d?.JE_Status,
          'JE Id': d?.JEID,
          'XEN Remarks': d?.XEN_Remarks,
          'XEN Status': d?.XEN_Status
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  // rowBackgroundColor(row) {
  //   if (row.JE_Status == 'Approved') {
  //     return '#b9ecb9';
  //   } else if(row.XEN_Status == 'Done'){
  //     return '#b9ecb9';
  //   } else return '#f9cece';
  // }

  onClickAppAction(row){
    this.showActionDialog = true;
    this.selectedRowData = row;
    this.surveyArea = row?.TotalArea;
    let reqBody = {
      AppId: row?.APP_ID,
      ProgId: row?.ProposedSystemId,
      ChunkId: row?.ChunkId
    }
    this.getAppData(reqBody);
    this.getEPCFarmerDetails(row?.AgreementNo, row?.OutletId, row?.ChunkId)
  }

  getEPCFarmerDetails(agreementNo, outletId, chunkId) {
    this.loader.start();
    this.vendorService
      .getEPCDetails(agreementNo, outletId, chunkId, this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          let resp: any = data;
          if (resp?.otherDetails['$values'].length > 0) {
            // this.epcDataForApproval = resp?.otherDetails['$values'];
            this.epcDataForAppLandDetails = resp?.landDetails['$values'];
          } else {
            // this.epcDataForApproval = [];
            this.epcDataForAppLandDetails = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For PV (Farmer)', `${agreementNo}, ${outletId}, ${chunkId}`, new Date(), `${data}`);
        },
        error: (err) => {
          // this.epcDataForApproval = [];
          this.epcDataForAppLandDetails = [];

          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For PV Error(Farmer)', `${agreementNo}, ${outletId}, ${chunkId}`, new Date(), `${err}`);
        },
      });
  }

  getAppData(reqBody) {
    this.loader.start();
    let sub = this.vendorService
      .getGeoAndAttachmentsEPC(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          // this.loading = false;
          
          if (data.ImagePathJE.length > 0 || data.listGPSCoordinatesJE.length > 0) {
            // this.imagePathJE = data.ImagePathJE;
            // this.listGPSCoordinatesJE = data.listGPSCoordinatesJE;
            // for (let index = 0; index < data.listGPSCoordinatesJE.length; index++) {
            //   let geoData = {
            //     CornerID: data.listGPSCoordinatesJE[index].CornerID,
            //     lat: data.listGPSCoordinatesJE[index].Latitude,
            //     lng: data.listGPSCoordinatesJE[index].Longitude,
            //   };
            //   this.geolocationsarray.push(geoData);
            // }
            // if (this.geolocationsarray.length == 0) {
            //   this.mapEnable = false;
            // } else {
            //   if (this.geolocationsarray && this.geolocationsarray.length > 0) {
            //     this.options.center = this.geolocationsarray[0];
            //   }
            //   this.mapEnable = true;
            //   this.geolocationsarray.forEach((row, index) => {
            //     this.addMarkers(row, index);
            //   });
            //   this.addOverlay();
            // }
  

            if(data.listGPSCoordinatesJE.length > 0){
              let geoCoordinates: any []= [];
              data.listGPSCoordinatesJE.forEach((array) => {
                let val = array.map((val) => ({
                  CornerID: val.CornerID,
                  lat: val.Latitude,
                  lng: val.Longitude
                }))
                geoCoordinates.push(val);
              })

              this.geoLocMulArray = geoCoordinates;

              this.onSave(0);
            }

            for (let index = 0; index < data.ImagePathJE.length; index++) {
              let imagesData = {
                attachment: data.ImagePathJE[index].ImagePath,
                attachmentRawUrl: data.ImagePathJE[index].ImagePath,
                document_type: data.ImagePathJE[index].DocumentType,
                displayName: data.ImagePathJE[index].DocumentType,
                name: data.ImagePathJE[index].DocumentType,
              };
              this.documentList.push(imagesData);
            }

          }
          else {
            // this.imagePathJE = [];
            // this.listGPSCoordinatesJE = [];
            this.showActionDialog = false;
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }

          this.activityRecordService.activityRecord( this.userId, 'EPC PV Update (App details)', reqBody?.AppId, new Date(), 'Success', JSON.stringify(reqBody) );
        },
        error: (err) => {
          this.showActionDialog = false;
          this.loader.close();
          this.activityRecordService.activityRecord( this.userId, 'EPC PV Update Error (App details)', reqBody?.AppId, new Date(), `${err}`, JSON.stringify(reqBody) );

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onSave(tableNo) {
    this.mapEnable = false;
    this.mapEnable = true;
    this.options.center = this.geoLocMulArray[tableNo][0];
    this.overlays = [];
    this.geoLocMulArray.forEach((arr, tableIndex) => {
      arr.forEach((row, index) => {
        this.addMarkers(row, index, tableIndex);
      });
    })
    
    this.addOverlay();
  }

  addOverlay() {
    this.overlays.forEach((val, index) => {
      if(val?.fillColor){
        this.overlays.splice(index, 1);
      }
    })

    this.geoLocMulArray.forEach(arr => {
      this.overlays.push(
        new google.maps.Polygon({
          paths: arr,
          strokeOpacity: 0.5,
          strokeWeight: 1,
          fillColor: '#1976D2',
          fillOpacity: 0.35,
        })
      );
    })
    

    setTimeout(()=>{
      this.calculateSurveyArea();
    }, 100)
  }

  calculateSurveyArea(){
    let area = 0;
    this.geoLocMulArray.forEach(array => {
      if(array.length >= 3 ){
        let polygon = new google.maps.Polygon({paths: array});
        area += this.calculateLandArea(polygon.getPath());
      }
    });
    this.landArea = Number((0.000247105*area).toFixed(2));
  }

  calculateLandArea(polygon){
    return google?.maps?.geometry?.spherical.computeArea(polygon)
  }

  // addMarkers(row: any, index) {
  //   this.overlays.push(
  //     new google.maps.Marker({
  //       position: { lat: row?.lat, lng: row?.lng },
  //       title: 'Coordinate ' + row?.CornerID,
  //       draggable: true,
  //       crossOnDrag: false
  //     })
  //   );
  // }

  onCloseActionDialog() {
    this.selectedRowData = null;
    this.isGPSError = false;
    clearInterval(this.refreshLocation);
    this.showActionDialog = false;
    this.mapEnable = false;
    this.geolocationsarray = [];
    this.overlays = this.overlays.filter(val => {
      return !val?.title?.includes('Coordinate')
    });
    this.documentList = [];
    // this.isPVSurveySubmitted = false;
    this.landArea = 0;
    this.surveyArea = null;
    this.addOverlay();
  }

  addMarkers(row: any, index, tableNo) {  
    this.overlays.push(
      new google.maps.Marker({
        position: { lat: row?.lat, lng: row?.lng },
        title: `${row?.CornerID}`,
        // draggable: false,
        draggable: false,
        crossOnDrag: false
      })
    );
  }

  // calculateLandArea(polygon) {
  //   return google.maps.geometry.spherical.computeArea(polygon)
  // }

  selectPreSurveyData(event) { }

  onClickSubmit(){

    if (this.selectedStatus?.flag == 'A' && (this.remarks == undefined || this.remarks == "")) {
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Add Remark' });
      return;
    }

    let reqBody = {
        ChunkId: this.selectedRowData?.ChunkId,
        OutletId: this.selectedRowData?.OutletId,
        AgreementNo: this.selectedRowData?.AgreementNo,
        ConId: this.selectedRowData?.ConId,
        AppID: this.selectedRowData?.APP_ID,
        ProgramID: this.selectedRowData?.ProposedSystemId,
        UserId: this.userId,
        NetworkId: this.ipAddress,
        TerminalId: this.ipAddress,
        Remarks: this.remarks,
        Status: this.selectedStatus?.flag
      }

    this.submitEPCWork(reqBody);
  }

  submitEPCWork(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.vendorService
      .insertReVerificationEPC(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });
            this.onCloseActionDialog();
            this.refreshTable();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For PV Submit', `${reqBody?.AppID}`, new Date(), `${data}`, reqBody);
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For PV Submit Error', `${reqBody?.AppID}`, new Date(), `${err}`, reqBody);
        },
      });
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

}
